import { render, staticRenderFns } from "./modalEditBusinessMember.vue?vue&type=template&id=dd3aa488&scoped=true&"
import script from "./modalEditBusinessMember.vue?vue&type=script&lang=js&"
export * from "./modalEditBusinessMember.vue?vue&type=script&lang=js&"
import style0 from "./modalEditBusinessMember.vue?vue&type=style&index=0&id=dd3aa488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3aa488",
  null
  
)

export default component.exports